interface IFinadaiStorage {
    apiToken?: string;
    [key: string]: any;
}

module finadai.services {
    import User = finadai.models.User;

    export class AuthService {
        static instanceName = "authService";
        username: string;
        currentUser: User;

        constructor(private $http: ng.IHttpService, private proxifier, private $q: ng.IQService, private $localStorage: IFinadaiStorage, private $injector) {
            this.currentUser = null;
        }

        isWhiteListStates(state) {
            return ['login', 'changePassword', 'forgotPassword', 'resetPassword', 'register', 'registerSuccess', 'findYourCredit', 'payYourCredit', 'validateAccount', 'accessAccount'].indexOf(state) >= 0;
        }

        isLoggedIn(): ng.IPromise<User> {
            var defer = this.$q.defer<any>();
            if (this.currentUser == null) {
                this.$http.post([this.proxifier(), 'auth', 'me'].join('/'), {}).then((response: ng.IHttpPromiseCallbackArg<finadai.models.http.responses.AuthMe>) => {
                    this.currentUser = response.data.user;
                    switch (this.currentUser.privilege) {
                        case "1":
                            this.currentUser.privilege = 'admin';
                            break;
                        case "2":
                            this.currentUser.privilege = 'agent';
                            break;
                        case "3":
                            this.currentUser.privilege = 'customer';
                            break;
                        case "4":
                            this.currentUser.privilege = 'operational';
                            break;
                    }
                    this.currentUser.states = ['app.dashboard', 'app.notFound'];
                    angular.forEach(this.currentUser.operations, item => {
                        switch (item) {
                            case 'login':
                                this.currentUser.states.push('login');
                                break;
                            case 'validateAccount':
                                this.currentUser.states.push('validateAccount', 'app.login');
                                break;
                            case 'accessAccount':
                                this.currentUser.states.push('accessAccount', 'app.login');
                                break;
                            case 'reset_password':
                                this.currentUser.states.push('app.changePassword', 'changePassword');
                                break;
                            case 'activities_index':
                                this.currentUser.states.push('app.activities.list');
                                break;
                            case 'activities_show':
                                this.currentUser.states.push('app.activities.detail');
                                break;
                            case 'agents_index':
                                this.currentUser.states.push('app.agents', 'app.agents.list');
                                break;
                            case 'agents_store':
                                this.currentUser.states.push('app.agents.create');
                                break;
                            case 'agents_update':
                                this.currentUser.states.push('app.agents.detail');
                                break;
                            case 'granters_index':
                                this.currentUser.states.push('app.granters', 'app.granters.list');
                                break;
                            case 'granters_store':
                                this.currentUser.states.push('app.granters.create');
                                break;
                            case 'granters_update':
                                this.currentUser.states.push('app.granters.detail');
                                break;
                            case 'customers_search':
                                this.currentUser.states.push('app.customers.detail', 'app.search.results');
                                break;
                            case 'customers_upload_file':
                                this.currentUser.states.push('app.upload');
                                break;
                            case 'negotiations_index':
                                this.currentUser.states.push('app.negotiations', 'app.negotiations.list');
                                this.currentUser.states.push('app.negotiations.paid', 'app.negotiations.paid');
                                break;
                            case 'negotiations_show':
                                this.currentUser.states.push('app.negotiations.create', 'app.negotiations.detail');
                                break;
                            case 'customers_get_info':
                                this.currentUser.states.push('app.customers.profile');
                                break;
                            case 'logs_index':
                                this.currentUser.states.push('app.customers.timeline');
                                break;
                            case 'maps_view':
                                this.currentUser.states.push('app.map');
                                break;
                            case 'reports_payments':
                                this.currentUser.states.push('app.payments', 'app.payments.list');
                                break;
                            case 'reports_activities':
                                this.currentUser.states.push('app.activities', 'app.activities.report');
                                break;
                            case 'customers_cancel_negotiation':
                                this.currentUser.states.push('app.customers.cancel_negotiation');
                                break;
                            case 'admin_create_negotiation':
                                this.currentUser.states.push('app.admin.create');
                                break;
                            case 'admin_search_customer':
                                this.currentUser.states.push('app.admin.search');
                                break;
                            case 'admin_find_negotiation':
                                this.currentUser.states.push('app.admin.find_negotiation');
                                break;
                            case 'admin_cancel_negotiation':
                                this.currentUser.states.push('app.admin.cancel_negotiation');
                                break;
                            case 'admin_update_customer':
                                this.currentUser.states.push('app.admin.update');
                                break;
                            case 'admin_find_customer':
                                this.currentUser.states.push('app.admin.find');
                                break;
                            case 'admin_create_single_reference':
                                this.currentUser.states.push('app.admin.create_reference');
                                break;
                            case 'admin_change_sic_customer':
                                this.currentUser.states.push('app.admin.change_sic');
                                break;
                        }
                    });

                    defer.resolve(this.currentUser);
                });
            }
            else {
                defer.resolve(this.currentUser);
            }
            return defer.promise;
        }

        changeDefaultPassword(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'agents', 'change_default_password'].join('/'), data);
        }

        sendInstructions(data): ng.IHttpPromise<finadai.models.http.responses.Message> {
            return this.$http.post([this.proxifier(), 'password', 'email'].join('/'), data);
        }

        resetPassword(data) {
            return this.$http.post([this.proxifier(), 'password', 'reset'].join('/'), data);
        }

        changePassword(data) {
            return this.$http.post([this.proxifier(), 'auth', 'change_password'].join('/'), data);
        }

        login(data): ng.IHttpPromise<finadai.models.http.responses.Login> {
            return this.$http.post([this.proxifier(), 'auth'].join('/'), data);
        }

        logout() {
            var self = this;
            return this.$http.get([this.proxifier(), 'auth'].join('/')).then(response => {
                delete this.$localStorage.apiToken;
                this.currentUser = null;
                return response;
            });
        }
    }

    var ignoreTokenUrls = [
        {method: "POST", url: "finadai/proxy/create_user"},
        {method: "GET", url: "finadai/proxy/validate_user"},
        {method: "POST", url: "finadai/proxy/search"},
        {method: "POST", url: "finadai/proxy/new_search"},
        {method: "POST", url: "password/email"},
        {method: "POST", url: "password/reset"},
    ];

    export var authHttpInterceptorName = "authHttpInterceptor";

    export function AuthHttpInterceptor($injector, $q: ng.IQService, $rootScope, $localStorage: IFinadaiStorage) {
        return {
            request: function (config) {
                var urlMatch = ignoreTokenUrls.filter(x => x.method == config.method && config.url.indexOf(x.url) >= 0);
                if (urlMatch.length == 0) {
                    config.headers.Authorization = $localStorage.apiToken;
                    console.log("url_auth", config.url);
                }
                return config;
            },
            responseError: function (rejection) {
                if (rejection.status == 401) {
                    $rootScope.stateChangeBypass = true;
                    $rootScope.$broadcast('preloader:hide');
                    $injector.get('$state').go('login');
                }
                return $q.reject(rejection);
            }
        }
    }
}
